<template>
  <div class="teacher-evaluation-list">
    <el-table :data="teacherEvaluationList" style="width: 100%">
      <el-table-column prop="teacherName" label="教师名称">
      </el-table-column>
      <el-table-column prop="teacherNumber" label="工号">
      </el-table-column>
      <el-table-column prop="isCharge" label="评价类型">
        <template slot-scope="scope">
          {{ scope.row.isCharge == 0 ? '班主任' : '科任老师' }}
        </template>
      </el-table-column>
      <el-table-column prop="avgNum" label="平均得分">
      </el-table-column>
      <!-- <el-table-column prop="sumScore" label="总分">
      </el-table-column> -->
      <!-- <el-table-column prop="num" label="评价人数">
      </el-table-column> -->
      <el-table-column prop="schoolYear" label="学年">
      </el-table-column>
      <el-table-column prop="semester" label="学期">
        <template slot-scope="scope">
          {{ scope.row.semester == 1 ? '第一学期' : '第二学期' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button type="success" size="small" @click="detailShow(scope.row)">统计详情
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <statisticalDetailsDialog v-show="statisticalDetailsShow" :statisticalDetailsShow.sync="statisticalDetailsShow"
      :statisticalDetails="statisticalDetails" />
  </div>
</template>

<script>
import statisticalDetailsDialog from "../statistical-details-dialog/statisticalDetails.vue";
export default {
  components: {
    statisticalDetailsDialog
  },
  props: ['teacherEvaluationList'],
  data() {
    return {
      statisticalDetailsShow: false,
      statisticalDetails: {}
    }
  },
  methods: {
    detailShow(row) {
      let {teacherNumber, teacherName, schoolYear, semester} = row;
      let data = {
        questionType: row.isCharge,
        schoolId: this.user.schoolId,
        teacherNumber,
        teacherName,
        schoolYear,
        semester,
      };
      this.get(this.$url.getTeacherRecordsProportion, data).then(res => {
        // console.log("获取单个教师统计结果==>", res);
        if(res.code !== 200) return this.$message.error(res.msg || "获取失败");
        this.statisticalDetails = res.data;
      });
      this.statisticalDetailsShow = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./teacherEvaluationList.scss";
</style>